export const eShippingStates = {
  New: 1,
  InProcess: 2,
  NotAccepted: 3,
  CanceledByClient: 4,
  InWarehouseKiev: 5,
  Unloaded: 6,
};
